module.exports = __webpack_public_path__ + "static/media/Customer-polls.4b4cba9f.svg";